import React from "react";
import { Criterion } from "../../services/evals";

interface CriterionRowViewModeProps {
  criterion: Criterion;
}

export const CriterionRowViewMode: React.FC<CriterionRowViewModeProps> = ({ criterion }) => {
  return (
    <div className="al-space-y-4">
      <div className="al-mb-3">
        <div className="al-text-xs al-font-semibold al-text-purple-700 al-uppercase al-mb-1">
          Criterion Name
        </div>
        <div className="al-bg-purple-50 al-border al-border-purple-200 al-p-3 al-rounded-lg al-text-sm al-whitespace-pre-wrap">
          {criterion.name}
        </div>
      </div>

      <div className="al-mb-3">
        <div className="al-text-xs al-font-semibold al-text-purple-700 al-uppercase al-mb-1">
          Description
        </div>
        <div className="al-bg-purple-50 al-border al-border-purple-200 al-p-3 al-rounded-lg al-text-sm al-whitespace-pre-wrap">
          {criterion.description}
        </div>
      </div>

      <div className="al-mb-3">
        <div className="al-text-xs al-font-semibold al-text-amber-700 al-uppercase al-mb-1">
          Tenant
        </div>
        <div className="al-bg-amber-50 al-border al-border-amber-200 al-p-3 al-rounded-lg al-text-sm al-whitespace-pre-wrap">
          {criterion.tenant === "All"
            ? "All Tenants"
            : `${criterion.tenant} Only`}
        </div>
      </div>
    </div>
  );
};
